document.querySelectorAll('.video-slideshow__media').forEach(function (container) {
  var slides = Array.prototype.slice.call(container.querySelectorAll('.video-slideshow__slide'));
  if (slides.length === 0) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    slides[current].pause();
    current = index;
    var next = slides[current];
    next.classList.add('is-active');
    next.currentTime = 0;
    if (!reducedMotion) next.play();
  }

  slides.forEach(function (slide, i) {
    slide.addEventListener('ended', function () {
      goTo((i + 1) % slides.length);
    });
  });

  if (!reducedMotion) {
    slides[0].play();
  }
});
